import React from 'react';
import { NavLink } from 'react-router-dom';
import { clsx } from 'clsx';
import OfflineStatusIndicator from '@/components/UI/OfflineStatusIndicator';
import {
  Home,
  Dumbbell,
  TrendingUp,
  User,
  BookOpen,
  Watch,
  Calendar,
  FileText,
  Users,
  Heart,
  Download
} from 'lucide-react';

const navigation = [
  { name: 'Dashboard', href: '/app/dashboard', icon: Home },
  { name: 'Calendar', href: '/app/calendar', icon: Calendar },
  { name: 'Workouts', href: '/app/workout/1/monday-am', icon: Dumbbell },
  { name: 'Templates', href: '/app/templates', icon: FileText },
  { name: 'How-to\'s', href: '/app/workout-howtos', icon: BookOpen },
  { name: 'Recovery', href: '/app/recovery', icon: Heart },
  { name: 'Export', href: '/app/export', icon: Download },
  { name: 'Social', href: '/app/social', icon: Users },
  { name: 'Progress', href: '/app/progress', icon: TrendingUp },
  { name: 'Wearables', href: '/app/wearables', icon: Watch },
  { name: 'Profile', href: '/app/profile/overview', icon: User },
];

export default function Navigation() {
  return (
    <nav className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:inset-y-0 lg:pt-16 lg:bg-white lg:border-r lg:border-gray-200">
      <div className="flex-1 flex flex-col min-h-0 pt-6">
        <div className="flex-1 flex flex-col pb-4 overflow-y-auto">
          <nav className="mt-5 flex-1 px-2 space-y-1">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) =>
                  clsx(
                    'group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors',
                    isActive
                      ? 'bg-primary-100 text-primary-900'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <item.icon
                      className={clsx(
                        'mr-3 flex-shrink-0 h-5 w-5',
                        isActive
                          ? 'text-primary-500'
                          : 'text-gray-400 group-hover:text-gray-500'
                      )}
                    />
                    {item.name}
                  </>
                )}
              </NavLink>
            ))}
          </nav>
        </div>

        {/* Sync Status Indicator at Bottom */}
        <div className="px-2 pb-4">
          <OfflineStatusIndicator navigationMode className="w-full" />
        </div>
      </div>
    </nav>
  );
}
